// store/blogStore.ts
import { create } from "zustand";
import { Post } from "../types/blog";


interface blogState {
    posts: Post[];
    setPosts: (posts: Post[]) => void;
    addPost: (post: Post) => void;
    getPostById: (id: string) => Post | undefined;
}

export const useBlogStore = create<blogState>((set, get) => ({
    posts: [],
    setPosts: (posts) => set({ posts }),
    addPost: (post) => set((state) => ({ posts: [...state.posts, post] })),
    getPostById: (id) => get().posts.find((p) => p.id === id),
}));
